/**
 * A picture for an asset that has no camera to take one (owner, 2026-09-28:
 * "computer/servers look very out of place as everything else has a photo
 * from the camera"). Drawn, not photographed — an icon for the kind — so a
 * grid of camera frames with a server among them still reads as pictures.
 *
 * Cameras never come here: a camera with no frame yet says so in words,
 * because a drawing of a camera in its place would look like a picture of
 * nothing wrong.
 */

import { Box, CardSim, HardDrive, Laptop, Monitor, Router, Server, Sun, type LucideIcon } from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  server: Server,
  nvr: HardDrive,
  recorder: HardDrive,
  desktop: Monitor,
  laptop: Laptop,
  router: Router,
  solar_controller: Sun,
  sim: CardSim,
};

export function kindIcon(kind: string): LucideIcon {
  return ICONS[kind] ?? Box;
}

export function KindPicture({ kind, label, size = 'thumb' }: { kind: string; label: string; size?: 'thumb' | 'large' }) {
  const Icon = kindIcon(kind);
  return (
    <span className={`kind-picture kind-picture-${size}`} role="img" aria-label={label}>
      <Icon aria-hidden="true" strokeWidth={1.25} />
    </span>
  );
}
